/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldDown: {
  name: 'arrow-bold-down';
  data: string;
} = {
  name: 'arrow-bold-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 15.5a.5.5 0 0 0 .384-.18l5-6A.5.5 0 0 0 13 8.5h-2.5V2A1.5 1.5 0 0 0 9 .5H7A1.5 1.5 0 0 0 5.5 2v6.5H3a.5.5 0 0 0-.384.82l5 6A.5.5 0 0 0 8 15.5Zm-3.932-6H6a.5.5 0 0 0 .5-.5V2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v7a.5.5 0 0 0 .5.5h1.932L8 14.219 4.068 9.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" transform="rotate(180 8 8)" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
